module.exports = __webpack_public_path__ + "static/media/pin_sos_grandine_highlighted.9d99d82c.png";